__turbopack_context__.v({
  "buttonWrapper": "K0vB4W_buttonWrapper",
  "flightCardWrapper": "K0vB4W_flightCardWrapper",
  "flightSelectorContainer": "K0vB4W_flightSelectorContainer",
  "flightSelectorTitle": "K0vB4W_flightSelectorTitle",
  "headerCell": "K0vB4W_headerCell",
  "headerCellCenter": "K0vB4W_headerCellCenter",
  "headerCellEnd": "K0vB4W_headerCellEnd",
  "returnWrapper": "K0vB4W_returnWrapper",
  "section": "K0vB4W_section",
  "sheetContent": "K0vB4W_sheetContent",
  "sheetCustomHeader": "K0vB4W_sheetCustomHeader",
  "sheetTitle": "K0vB4W_sheetTitle",
  "wrapper": "K0vB4W_wrapper",
});
